export default __webpack_public_path__ + "static/media/4.dec12508.svg";